import React, { useEffect, useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Menu, X } from 'lucide-react';
const navLinks = [{
  name: 'Home',
  href: '#hero'
}, {
  name: 'About Us',
  href: '#about'
}, {
  name: 'Our Minerals',
  href: '#collection'
}, {
  name: 'Certifications',
  href: '#certifications'
}, {
  name: 'Global Operations',
  href: '#operations'
}, {
  name: 'Contact',
  href: '#contact'
}];
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  return <motion.nav className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${isScrolled ? 'bg-white shadow-sm py-4' : 'bg-transparent py-6'}`} initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-174">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        <div className="flex justify-between items-center" data-id="element-176">
          {/* Logo */}
          <a href="#" className="flex items-center" data-id="element-177">
            <img src="https://cdn.magicpatterns.com/uploads/v9c2EAFGxnXmFVasKusPuE/............png" alt="Kale Cooperative Minerals SPRL" className="h-16 w-auto" data-id="element-178" />
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex space-x-8" data-id="element-179">
            {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-drc-blue ${isScrolled ? 'text-gray-600' : 'text-white/90 hover:text-white'}`} data-id="element-180">
                {link.name}
              </a>)}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-181">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`p-2 rounded-md ${isScrolled ? 'text-gray-900' : 'text-white'}`} data-id="element-182">
              {isMobileMenuOpen ? <X size={24} data-id="element-183" /> : <Menu size={24} data-id="element-184" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} className="md:hidden bg-white border-t" data-id="element-185">
          <div className="px-4 pt-2 pb-8 space-y-1" data-id="element-186">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-4 text-base font-medium text-gray-900 hover:bg-gray-50 hover:text-drc-blue border-b border-gray-100" data-id="element-187">
                {link.name}
              </a>)}
          </div>
        </motion.div>}
    </motion.nav>;
}